import { render, staticRenderFns } from "./_header_page.vue?vue&type=template&id=053b2f54"
import script from "./_header_page.vue?vue&type=script&lang=js"
export * from "./_header_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports